import { Component, Input, OnInit } from '@angular/core';
import { ChartData, ChartOptions, ChartType } from 'chart.js';
import { ApiServiceBase } from 'src/app/Services/api.service.base';

@Component({
    selector: 'app-validationuserusageserieschart',
    templateUrl: './validationuserusageserieschart.component.html',
    styleUrls: ['./validationuserusageserieschart.component.scss'],
    standalone: false
})
export class ValidationUserUsageSeriesChart implements OnInit {
    @Input()
    public Title : string = "Validation User Code Usage";
    @Input()
    public Period : string = "thisweek";
    @Input()
    public ChartType : string = "line";
    @Input()
    public Height : number = 100;
    @Input()
    public ProfileId : number =  0;
    @Input()
    public ValidationUserId : number =  0;

    public Url : string= "";
  
    public ChartOptions : ChartOptions = {
      elements: {
        line: {
          tension: 0.2
        }
      },
      scales:{
        yAxes:{
          beginAtZero: true,
          ticks: {
            precision : 0
          }
        }
      },
      plugins: {
        legend : { display: false }
      }
    };
    public ChartData : ChartData = {
      datasets: [],
    };
    public ChartColors: string[] = [
      'green'
    ];
  
    constructor(private apiService : ApiServiceBase) { }
  
    ngOnInit(): void {

      this.Url = 'parking/validation/profiles/' + this.ProfileId + '/users/' + this.ValidationUserId + '/series/' + this.Period

      this.apiService.Get<any>(this.Url).then(result => {
        this.ChartData =  {
          datasets: [{
                  data: result.Values,
                  label: 'Validation codes applied',
                  pointBackgroundColor: ['green'],
                  pointBorderColor: ['green'],
                  backgroundColor: ['green'],
                  borderColor: ['green']
          }],
          labels: result.Labels,
        };
      });
    }
  
  }
  
